/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function HiddenAndNoIndex({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} clipPath="url(#HiddenAndNoIndex_svg__a)"><path d="M8.75 11.193a2.88 2.88 0 0 1 2.882-2.883m2.516 1.475a2.882 2.882 0 0 1-3.742 4.017" /><path strokeLinejoin="round" d="m13.724 13.387 1.167 1.168M15.336 8.19 8.99 15" /><path d="m1.182 4.442-.094-.149a.3.3 0 0 1 0-.311c.277-.462 1.224-1.816 2.955-2.197m3.339.622A5.1 5.1 0 0 1 8.885 3.98a.3.3 0 0 1 0 .312c-.326.54-1.563 2.297-3.899 2.297a4.3 4.3 0 0 1-1.569-.29" /><path strokeLinejoin="round" d="M8.399 1 2.025 7.374" /></g><defs><clipPath id="HiddenAndNoIndex_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;